(function () {
  'use strict';

  angular.module('ringbaPortal').component('tagValueDropdown', {
    bindings: {
      tagId: '<',
      tagIds: '<',
      tagCriteria: '<',
      onTagChange: '&'
    },
    controller: TagValueDropdownController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/tag-value-dropdown/tag-value-dropdown.view.html'
  });

  function TagValueDropdownController(
    _,
    accountsService,
    bsLoadingOverlayService,
    tagsValuesService,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.$onChanges = onChanges;

    function onChanges() {
      vm.loaderRefId = vm.loaderRefId || 'tag-value-dropdown-loader-' + _.uniqueId();
      vm.tagValueOptions = tagsValuesService.getOptionsForDropdown(_getTagId());
      _loadData(tagsValuesService.getTagDataFunction(accountsService.currentAccountId, vm.tagId, vm.tagIds));
    }

    function _loadData(getData) {
      if (!getData) {
        return;
      }

      _showLoader(vm.loaderRefId);

      getData().then(function (response) {
        let tempList = response.data && response.data[vm.tagValueOptions.responseProperty];

        if (vm.tagValueOptions.filterProperty) {
          tempList = _.filter(tempList, function filterList(item) {
            return item && item[vm.tagValueOptions.filterProperty];
          });
        }


        vm.list = _.sortBy(tempList, [function(o) { return vm.tagValueOptions.displayProperty ? o[vm.tagValueOptions.displayProperty] : o.name; }]);

      }).catch(utils.errorHandler)
        .finally(function () {
          _hideLoader(vm.loaderRefId);
        });

    }

    function _showLoader(loaderRef) {
      vm.showLoader = true;
      bsLoadingOverlayService.start({
        referenceId: loaderRef
      });
    }

    function _hideLoader(loaderRef) {
      vm.showLoader = false;
      bsLoadingOverlayService.start({
        referenceId: loaderRef
      });
    }

    function _getTagId() {
      if (vm.tagId) {
        return vm.tagId;
      }

      return vm.tagIds;
    }
  }
})();
